export default "__VITE_ASSET__DcYlU5lB__"